import { useDispatch, useSelector } from 'react-redux';
import { TemplatesModal } from '../baseComponents/Modal';
import { Button, Text } from '../baseComponents';
import { Input } from 'antd';
import { getDotPhraseAction } from '../../store/actions/templatesexchange.action';
import { ProfileLogo } from 'src/components';
import './TemplatesExchangeModal.scss';
import { analytics } from 'src/services';

const { TextArea } = Input;
const DotPhraseModal = ({ isOpen, setIsOpen, dotPhraseOverrideId }) => {
  const dispatch = useDispatch();

  const { getDotPhraseByIdList, getAllTemplatesExchangeList } = useSelector(
    (state) => state?.templatesState
  );

  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );

  const user = getDotPhraseByIdList?.dot_phrase?.total_shares;
  const header = getDotPhraseByIdList?.dot_phrase?.title;
  const names = getDotPhraseByIdList?.practitioner_name;
  const template = getDotPhraseByIdList?.dot_phrase?.template;
  const nameWithoutTitle = names?.replace('Dr. ', '');
  const showGetTemplateButton =
    getDotPhraseByIdList?.dot_phrase?.practitioner_id !==
    currentPractitioner?.practitioner_id;

  const handleGetDotPhase = () => {
    analytics.track('Clicked Get Dot Phrase', { email: user?.email });
    const appendedTitle = `${header} (${names})`;
    dispatch(getDotPhraseAction(dotPhraseOverrideId, setIsOpen, appendedTitle));
  };

  const sections = [
    {
      heading: (
        <div className="ml-2">
          <div className="text-3xl ">{header} </div>
          <div className="flex justify-between">
            <div
              className="ant-dropdown-link -mt-1"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <div className="profile-wrapper flex items-center pt-3">
                <ProfileLogo
                  getAllTemplatesExchangeList={getAllTemplatesExchangeList}
                  name={nameWithoutTitle}
                  className={'profile-popover-logo mr-1 sm:mr-2 lg:mr-3'}
                  practitioner_name={names}
                />
                <Text
                  type={'span'}
                  className="user-name hidden sm:block mr-1 sm:mr-2 lg:mr-3 text-black text-base"
                >
                  {names}
                </Text>
              </div>
            </div>
            {showGetTemplateButton && (
              <div className="">
                <Button
                  type={'button'}
                  onClick={() => {
                    handleGetDotPhase();
                  }}
                  className={'text-base'}
                >
                  Get dot phrase
                </Button>
              </div>
            )}
          </div>
        </div>
      ),
      fields: [
        {
          name: 'sections',
          type: 'label',
          title: (
            <div className="mt-2">
              <div className="flex justify-between">
                <div className="border-0  p-2 px-4 bg-[#f8f8f8] w-4/6 rounded-xl">
                  <div className="text-xl py-3  font-medium">
                    Dot phrase sections
                  </div>
                  <div className={`overflow-auto   h-64`}>
                    <TextArea
                      bordered={false}
                      rows={10}
                      placeholder="template "
                      style={{
                        resize: 'none',
                        fontFamily: 'Poppins',
                      }}
                      value={template}
                    />
                  </div>
                </div>
                <div className="border-2 w-60 self-end rounded-xl py-7 px-4 h-30">
                  <p>
                    {' '}
                    {user} {user === 1 ? 'user' : 'users'}
                  </p>
                </div>
              </div>
            </div>
          ),
        },
      ],
    },
  ];

  return (
    <TemplatesModal
      open={isOpen}
      sections={sections}
      className={`template-modal`}
      closable={true}
      centered={true}
      submitButtonText=""
      cancelButtonText=""
      handleCancel={() => {
        setIsOpen(false);
      }}
      handleSubmit={() => {}}
    />
  );
};

export default DotPhraseModal;
